import React from 'react';
import parse from 'html-react-parser';

function renderItem(item, index) {
  switch (item.type) {
    case 'p':
      return <p key={index}>{parse(item.content)}</p>;
    case 'img':
      return <img key={index} src={item.url} alt="" className={item.class} />;
    case 'hr':
      return <hr key={index}></hr>;
    case 'a':
      return <a key={index} target='_blank' rel="noreferrer" href={item.url}>[ {item.label} ]</a>;
    case 'h1':
      if (!Array.isArray(item.links) || item.links.length === 0) {
        return <h1 key={index} className="project-title-large">{item.content}</h1>;
      }
      
      return <h1 key={index} className="project-title-large">{item.content} {item.links.map((link, index) => renderItem(link, index))}</h1>;
    case 'p-note':
      return <p key={index} className="note">{parse(item.content)}</p>
    default:
      return null;
  }
}

function ProjectDetails(details) {
  return <div className="project-details">{details.map((detail, index) => renderItem(detail, index))}</div>;
}

const ProjectDetail = ({ project }) => (
  <div className={`project-detail ${project.id}`}>
    <div className="project-content">
      <div className="project-header-detail">
        <h1 className="project-title-large">{project.title}</h1>
      </div>
      
      {ProjectDetails(project.details)}
    </div>
  </div>
);

export default ProjectDetail;